import { reduxForm } from "redux-form"
import { RESEND_FORM_NAME } from "../constants"
import ResendFormView from "../components/ResendFormView.react"

export default reduxForm({
  form: RESEND_FORM_NAME,
  enableReinitialize: true,
})(ResendFormView)
